let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5tz7G"), load("eEyVs"), load("hhss7"), load("i8Yee")]).then(() => parcelRequire('de33F'));